module.exports = __webpack_public_path__ + "static/step2-a1c7261a052d3a050dc1f2ef777b5d3a.mp4";